import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Address } from './models/address.model';

export interface AddressState extends EntityState<Address> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'address', idKey: 'AddressType', cache: { ttl: 20000 } })
export class AddressStore extends EntityStore<AddressState> {
  constructor() {
    super();
  }
}
